import { login as cognitoLogin, refresh as cognitoRefresh } from './cognito';
const STORAGE_KEY = 'tl.outlook.session.v1';
let current = loadFromStorage();
function loadFromStorage() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    }
    catch {
        return null;
    }
}
function persist(s) {
    current = s;
    if (s)
        localStorage.setItem(STORAGE_KEY, JSON.stringify(s));
    else
        localStorage.removeItem(STORAGE_KEY);
}
export function getSession() {
    return current;
}
export function isAuthenticated() {
    return !!current && current.expiresAt > Date.now() + 30000;
}
export async function loginWithPassword(email, password) {
    const r = await cognitoLogin(email, password);
    const s = {
        idToken: r.IdToken,
        refreshToken: r.RefreshToken,
        expiresAt: Date.now() + r.ExpiresIn * 1000,
        email,
        source: 'cognito',
    };
    persist(s);
    return s;
}
export function setSsoSession(idToken, expiresInSec = 3600) {
    const s = {
        idToken,
        expiresAt: Date.now() + expiresInSec * 1000,
        source: 'sso',
    };
    persist(s);
    return s;
}
export async function getAuthToken() {
    if (!current)
        throw new Error('Not authenticated');
    if (current.expiresAt > Date.now() + 30000)
        return current.idToken;
    if (current.source === 'cognito' && current.refreshToken && current.email) {
        const r = await cognitoRefresh(current.email, current.refreshToken);
        persist({ ...current, idToken: r.IdToken, expiresAt: Date.now() + r.ExpiresIn * 1000 });
        return r.IdToken;
    }
    // SSO without refresh — caller must re-auth via dialog.
    throw new Error('Session expired, please sign in again');
}
export function logout() {
    persist(null);
}
